import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';

import Layout from '../Components/Layout/Layout';

const PageNotFoundPage = ({ user, config, cmsSourceFirebase, actions }) => {
    const page = {
        title: '404 - Page not found',
        className: 'page-not-found',
    };

    return (
        <Layout {...{ page, user, config, cmsSourceFirebase, actions }}>
            <h1>{page.title}</h1>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(PageNotFoundPage);
